import { AbstractControl } from '@angular/forms';

export class FileRequiredValidator {
  static validator(control: AbstractControl) {
    const file = control.value;

    return file ? {} : { fileRequired: true };
  }
}
